import { sendGet, sendUpload } from "./axios";

const fileForm = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return formData;
};

export const postImportPreview = (file) =>
  sendUpload("/dm/data/import/preview", fileForm(file));
export const postImportStart = (file) =>
  sendUpload("/dm/data/import/start", fileForm(file));
export const getImportJobs = () => sendGet("/dm/data/import/jobs");
export const getImportJob = (jobId) => sendGet(`/dm/data/import/jobs/${jobId}`);
